// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__g_V_q","unreadBadge":"styles_unreadBadge__2-2xf","modalContent":"styles_modalContent__1qRRt","modal":"styles_modal__3mvf_"};